import type { Component } from "schemas/component";

export const getSharedStateKey = (
  component: Pick<Component, "id" | "type">,
  name: string,
) => {
  return `${component.id}.${name}`;
};
